import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'randValue'
})
export class RandValuePipe implements PipeTransform {
    public transform(value: number, decimals: number = 0): string {
        if (value === null || value === undefined) {
            return decimals > 0 ? 'R 0,00' : 'R 0';
        }

        if (decimals === 0) {
            const roundedNoDecimals: number = Math.round(value);
            const formatted: string = roundedNoDecimals.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            return `R ${formatted}`;
        }

        const factor: number = Math.pow(10, decimals);
        const rounded: number = Math.round(value * factor) / factor;
        const parts: Array<string> = rounded.toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return `R ${parts.join(',')}`;
    }
}
